import { useTranslation } from 'react-i18next';
import styles from '../Filter.module.scss';

export const NoResults = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.noResultsContainer}>
      {t('No results found')}
    </div>
  )
}